import { render, staticRenderFns } from "./TasksProject2.vue?vue&type=template&id=1ad2afa6&scoped=true"
import script from "./TasksProject2.vue?vue&type=script&lang=js"
export * from "./TasksProject2.vue?vue&type=script&lang=js"
import style0 from "./TasksProject2.vue?vue&type=style&index=0&id=1ad2afa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2afa6",
  null
  
)

export default component.exports